var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import ErrorHandler from '@/support/ErrorHandler';
import SelectFilter from '@/components/select-filter/SelectFilter';
import { Room } from '@/models/Room';
let AddRoomDialog = class AddRoomDialog extends Vue {
    constructor() {
        super(...arguments);
        this.room = new Room();
    }
    mounted() { }
    close() {
        this.$emit('input', false);
        this.clear();
    }
    create() {
        this.room
            .create()
            .then(() => {
            this.$emit('roomAdded');
            this.$emit('input', false);
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
        this.clear();
    }
    clear() {
        this.room = new Room();
    }
};
AddRoomDialog = __decorate([
    Component({
        components: {
            SelectFilter,
        },
    })
], AddRoomDialog);
export default AddRoomDialog;
